// extracted by mini-css-extract-plugin
export default {"root":"_3WO1s","small":"_19D7e","normal":"m2qUO"};